// @ts-check
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import App from './App.jsx';
import Login from './pages/Login.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Branches from './pages/Branches.jsx';
import BranchDetail from './pages/BranchDetail.jsx';
import Help from './pages/Help.jsx';
import { useAuth } from './store.js';
import './styles.css';

function Protected({ children }) {
  const token = useAuth((s) => s.token);
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

ReactDOM.createRoot(/** @type {HTMLElement} */ (document.getElementById('root'))).render(
  <BrowserRouter>
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Protected><App /></Protected>}>
        <Route index element={<Dashboard />} />
        <Route path="branches" element={<Branches />} />
        <Route path="branches/:id" element={<BranchDetail />} />
        <Route path="help" element={<Help />} />
      </Route>
    </Routes>
  </BrowserRouter>,
);
